import { render } from "./defaultLayout.vue?vue&type=template&id=c0bec480&ts=true"
import script from "./defaultLayout.vue?vue&type=script&lang=ts"
export * from "./defaultLayout.vue?vue&type=script&lang=ts"

import "./defaultLayout.vue?vue&type=style&index=0&id=c0bec480&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__